import { Button, Divider, Form, Input, Modal, Select, Tooltip } from "antd";
import React, { useRef } from "react";
import ItemsService, { UnitTypesOption } from "../../Services/ItemsService";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/PageRoute";
import { QuestionCircleOutlined } from "@ant-design/icons";

const UnitModel: React.FC<{
  open: boolean;
  data: any;
  setTrigger: any;
  onCancel: any;
  setAddUnitVal?: (param: string) => void;
}> = (props) => {
  const autoCompleteRef = useRef<any>(null);
  const [form] = Form.useForm();
  const { currentClient } = useClient();
  const { openNotification } = React.useContext(notificationContext);
  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);

  // Post Api
  const postItem = () => {
    form.validateFields().then(async (value: any) => {
      setSaveButtonLoading(true);
      let data = {
        ...value,
      };

      await ItemsService.postUnit(data, currentClient?.id, props.data?.id)
        .then((res: any) => {
          if (res.result) {
            props?.setAddUnitVal && props?.setAddUnitVal(res?.result);
            openNotification(
              "success",
              `Item Unit ${
                props.data?.id ? "updated successfully." : "added successfully."
              }`
            );
            props.onCancel();
            setSaveButtonLoading(false);
            props.setTrigger((x: boolean) => !x);
            console.log(res);
          } else {
            setSaveButtonLoading(false);
            openNotification("error", res.message);
          }
        })
        .catch((ex: any) => {
          setSaveButtonLoading(false);
          openNotification("error", ex);
          console.error(ex);
        });
    });
  };

  // Get Api
  React.useEffect(() => {
    if (props?.data?.id) {
      form.setFieldsValue({ ...props.data });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.data.id]);
  // getItemInventory;

  // --------- InitialValues in Add Item Model ---------
  const initialValues = {};
  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.focus();
      }
    }, 100); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, []); // Ensures autofocus after initial render

  return (
    <div>
      <Modal
        open={props.open}
        title={props?.data.id ? "Update Unit" : "New Unit"}
        width={400}
        onCancel={() => props.onCancel()}
        style={{ maxHeight: `calc(100% - 100px)`, overflowY: "auto", top: 180 }}
        footer={
          <div style={{ marginTop: "0px" }}>
            <Button
              onClick={() => {
                form.resetFields();
                props.onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              className="modelSaveButtonMargin"
              type="primary"
              onClick={() => postItem()}
              loading={saveButtonLoading}
            >
              {!props?.data.id ? "Save" : "Update"}
            </Button>
          </div>
        }
      >
        <Divider className="ca-model-css" />
        {/* <Spin indicator={antIcon} spinning={modelLoading}> */}
        <Form
          form={form}
          name="item"
          autoCapitalize="false"
          requiredMark={true}
          initialValues={initialValues}
          colon={false}
          labelAlign="left"
          labelCol={{ xs: 10, sm: 9 }}
          wrapperCol={{ xs: 14, sm: 15 }}
          labelWrap={true}
        >
          <Form.Item
            label="Unit Name"
            name="name"
            rules={[
              { required: true, message: "Unit's name is required" },
              {
                pattern: /^[A-Za-z0-9 ]{3,20}$/,
                message:
                  "Only alphanumeric value having minimum 3 or maximum length 20 is allowed",
              },
              {
                min: 3,
                max: 20,
                message:
                  "Please enter minimum 3 or maximum 20 alphanumeric value",
              },
            ]}
            className="input-item"
          >
            <Input
              placeholder="Unit name"
              onInput={(e: any) => {
                e.target.value = e.target.value.toUpperCase();
              }}
              ref={autoCompleteRef}
            />
          </Form.Item>

          <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: "Type is required" }]}
            className="input-item"
          >
            {/* <Input placeholder="Type" /> */}
            <Select placeholder="Select type" options={UnitTypesOption} />
          </Form.Item>

          <Form.Item
            rules={[{ required: true, message: "Short Name is required" }]}
            label={
              <>
                Short Name
                <Tooltip
                  title="Maximum length is three characters"
                  placement="top"
                  color="#4b5b95"
                >
                  <QuestionCircleOutlined style={{ marginLeft: "3px" }} />
                </Tooltip>
              </>
            }
            name="shortName"
            className="input-item"
          >
            <Input
              placeholder="Short name"
              maxLength={3}
              onInput={(e: any) => {
                e.target.value = e.target.value.toUpperCase();
              }}
            />
          </Form.Item>
        </Form>
        {/* </Spin> */}
        <Divider className="ca-model-css" />
      </Modal>
    </div>
  );
};

export default UnitModel;
